import { useMemo } from 'react'
import { useUserContext } from '@vp/ubik-context'
import { FEATURE_GATES } from 'shared/featureGates/constants'
import { isFeatureGateEnabled, parseForcedFeatureGates } from 'shared/featureGates'

export const useFeatureGate = (gate: FEATURE_GATES): boolean => {
  const { featureFlags, queryStrings } = useUserContext()

  return useMemo(() => {
    const forced = parseForcedFeatureGates(queryStrings?.['forceFeatureGate'])
    if (forced.has(gate)) {
      return true
    }
    return isFeatureGateEnabled(featureFlags, gate)
  }, [featureFlags, queryStrings, gate])
}
